// extracted by mini-css-extract-plugin
export default {"list":"Links_list__UdkBo","card":"Links_card__HM0EY","link":"Links_link__qYcb7","img":"Links_img__8H6Ca","name":"Links_name__OR2Ff"};